import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import {
  ItemTitle,
  Label,
  SectionTitle
} from "sweet-web/components/universal/Text";
import VenuePreview from "sweet-web/components/universal/VenuePreview";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Activated: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue } = props;

  const previewVenue = () => props.history.push(`/listing/${venueId}/preview`);

  return (
    <Wrapper>
      <Section>
        <SectionTitle style={{ marginBottom: 0 }}>
          Congratulations!
        </SectionTitle>
        <Label style={{ marginBottom: 30 }}>
          You successfully created your listing
        </Label>
        <VenuePreview
          style={{ width: 400, margin: 0 }}
          venue={venue}
          onClick={previewVenue}
        />
      </Section>
      <Section>
        <SectionTitle style={{ marginBottom: 20 }}>Next Steps</SectionTitle>
        <ItemTitle>
          Our team continues to build out the Sweet website and mobile app
        </ItemTitle>
        <ItemTitle>Sweet launches publicly on February 1</ItemTitle>
        <ItemTitle>
          Your space is featured on Sweet and customers can directly inquire and
          book!
        </ItemTitle>
      </Section>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state)
  };
};
const connector = connect(mapState);

export default connector(Activated);
